import { put, takeLeading } from 'redux-saga/effects';

import addressApi from 'api/address';
import { apiErrorHandler } from 'utils';

import { GET_PROVINCE_LIST, GET_DISTRICT_LIST, GET_WARD_LIST } from './actionTypes';
import {
  actionGetProvinceListSuccess,
  actionGetProvinceListFailed,
  actionGetDistrictListSuccess,
  actionGetDistrictListFailed,
  actionGetWardListSuccess,
  actionGetWardListFailed,
} from './actions';

function* getAddressList(payload) {
  try {
    const response = yield addressApi.getAddress(payload.payload);

    switch (payload.type) {
      case GET_PROVINCE_LIST: {
        yield put(actionGetProvinceListSuccess(response.payload));
        break;
      }

      case GET_DISTRICT_LIST: {
        yield put(actionGetDistrictListSuccess(response.payload));
        break;
      }

      case GET_WARD_LIST: {
        yield put(actionGetWardListSuccess(response.payload));
        break;
      }

      default: {
        break;
      }
    }
  } catch (error) {
    apiErrorHandler(error);

    switch (payload.type) {
      case GET_PROVINCE_LIST: {
        yield put(actionGetProvinceListFailed());
        break;
      }

      case GET_DISTRICT_LIST: {
        yield put(actionGetDistrictListFailed());
        break;
      }

      case GET_WARD_LIST: {
        yield put(actionGetWardListFailed());
        break;
      }

      default: {
        break;
      }
    }
  }
}

export default function* addressSaga() {
  yield takeLeading(GET_PROVINCE_LIST, getAddressList);
  yield takeLeading(GET_DISTRICT_LIST, getAddressList);
  yield takeLeading(GET_WARD_LIST, getAddressList);
}
